<script lang="ts" setup generic="T">
import { computed } from 'vue'

import { type CompletionOption, isCompletionOption } from './types'

/**
 * !!TODO do not use anymore deprecated props.
 * Usage of this component must be migrate to use completionOptions instead
 * the component has been updated to use both deprecated and completionOption too
 *
 * !!TODO remove deprecated props later and useless getOption<property> after full migration
 *
 * See [https://app.clickup.com/t/2628858/WEB-3852] : migration task
 */
const props = withDefaults(defineProps<{
  /**
   * @deprecated
   * use completionOptions instead
   */
  completionList?: unknown[]
  isLoading: boolean
  /**
   * @deprecated
   * use completionOptions instead
   */
  titleProp?: string
  /**
   * use completionOptions instead
   * @deprecated
   */
  descriptionProp?: string
  completionOptions?: CompletionOption<T>[]
}>(), {
  completionList: () => [],
  isLoading: false,
  titleProp: null,
  descriptionProp: null,
  completionOptions: () => []
})

const emit = defineEmits<{
  (e: 'select-item', value: unknown): void
  (e: 'select-option', value: T): void
}>()

const options = computed(() => props.completionOptions.length > 0 ? props.completionOptions : props.completionList)

/**
 * Method used to handle both behavior completionOption and completion Items
 * @param option
 */
function handleClick(option: unknown | CompletionOption<T>) {
  if (isCompletionOption(option)) {
    return emit('select-option', option.value as T)
  }

  return emit('select-item', option)
}

/**
 * Method used to handle both behavior completionOption and completion Items
 * @param option
 */
function getOptionTitle(option: unknown | CompletionOption<T>) {
  if (isCompletionOption(option)) {
    return option.title
  }
  return option[props.titleProp]
}

/**
 * Method used to handle both behavior completionOption and completion Items
 * @param option
 */
function getOptionDescription(option: unknown | CompletionOption<T>) {
  if (isCompletionOption(option)) {
    return option.description
  }

  return option[props.descriptionProp]
}

/**
 * Method used to handle both behavior completionOption and completion Items
 * @param option
 */
function getOptionKey(option: unknown | CompletionOption<T>) {
  if (isCompletionOption(option)) {
    return option.key
  }
  // @ts-expect-error prefer usage of completionOption instead
  return option.reference
}
</script>

<template>
  <div class="row gx-0 autocompletion-container">
    <div
      v-if="isLoading"
      class="autocompletion"
    >
      <div class="loader loader-sm loader-center my-1" />
    </div>
    <div
      v-else-if="options.length"
      class="autocompletion"
    >
      <div
        v-for="option in options"
        :key="getOptionKey(option)"
        class="autocompletion__item"
        @click="handleClick(option)"
      >
        <span>
          <span class="autocompletion__item-title">{{ getOptionTitle(option) }}</span>
          <span class="autocompletion__item-subtitle">{{ getOptionDescription(option) }}</span>
        </span>
      </div>
    </div>
    <div
      v-else
      class="autocompletion autocompletion--padded"
    >
      Aucun résultat
    </div>
  </div>
</template>
